export function formatQuoteDate(createdOn) {
  return createdOn?.toDate?.()?.toLocaleDateString() ?? '—';
}

export function maskVendorLabel(value) {
  const text = String(value || '').trim();
  if (!text) return '—';
  if (text.length === 1) return `${text}***`;
  return `${text[0]}***${text[text.length - 1]}`;
}

export function formatQuoteProductTypeList(products = []) {
  if (!products.length) return '—';
  return products.map((product) => product.productType).filter(Boolean).join(', ') || '—';
}
